import { render, staticRenderFns } from "./tabs-nav-action.vue?vue&type=template&id=3dc5385c&"
import script from "./tabs-nav-action.vue?vue&type=script&lang=js&"
export * from "./tabs-nav-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports